import TalentCertificatesList from './TalentCertificatesList';

export default TalentCertificatesList;
